// PlantOverviewStore lived in the removed accounting views module. Operations
// currently registers no view stores; keep the exported list so appStoresConfig
// can spread it.
const operationsStoreList: { name: string; store: unknown }[] = [];

export default operationsStoreList;
